
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from '@/store/user/moduleUser.js'
import profile from '@/store/profile/moduleProfile.js'
import application from '@/store/application/moduleApplication.js'
import draft from '@/store/draft/moduleDraft.js'
import community from '@/store/community/moduleCommunity.js'
import communityUpdates from '@/store/communityupdates/moduleCommunityUpdate.js'
import calculator from '@/store/calculator/moduleCalculator.js'
import file from '@/store/file/moduleFile.js'
import property from '@/store/property/moduleProperty.js'
import person from '@/store/person/modulePerson.js'
import permission from '@/store/permission/modulePermission.js'
import intro from '@/store/intro/moduleIntro.js'
import organisation from '@/store/organisation/moduleOrganisation.js'
import codes from '@/store/codes/moduleCodes.js'
import digitalApplication from '@/store/digitalApplication/moduleDigitalApplication.js'
import cloudinary from '@/store/cloudinary/moduleCloudinary.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    profile,
    application,
    draft,
    community,
    communityUpdates,
    calculator,
    file,
    property,
    person,
    permission,
    intro,
    organisation,
    codes,
    digitalApplication,
    cloudinary
  },
  plugins: [createPersistedState({
    paths: [
      'user.currentUser',
      'user.loggedInState',
      'communityUpdates.dissMissedUpdates',
      'permission.inviteCode'
    ] // Path to state which should be persisted
  })]
})
